module.exports = __webpack_public_path__ + "img/fk.f287bd40.svg";